import { useMemo } from 'react';
import { useAuthStore } from '@/stores/useAuthStore';
import { useCompanyStore } from '@/stores/useCompanyStore';
import { COMPANY_ROLE_PREFIX, ROLE_TEAM_MANAGER } from './navigation';

/**
 * Rôles applicatifs, plus le rôle dans la société sélectionnée (DIRECTOR => COMPANY_DIRECTOR) et TEAM_MANAGER s'il y
 * manage au moins une équipe
 */
export function accessRoles(roles: string[], companyRole: string | null | undefined, managesATeam = false): string[] {
  return [
    ...roles,
    ...(companyRole ? [`${COMPANY_ROLE_PREFIX}${companyRole}`] : []),
    ...(managesATeam ? [ROLE_TEAM_MANAGER] : []),
  ];
}

/**
 * Rôles donnant accès aux pages (navigation, RequireAccess) : changent avec la société sélectionnée, une fois son
 * rattachement chargé (ceux de la précédente entre-temps)
 */
export function useAccessRoles(): string[] {
  const roles = useAuthStore((state) => state.user?.roles) ?? NO_ROLES;
  const companyRole = useCompanyStore((state) => state.membership?.companyRole);
  const managesATeam = useCompanyStore((state) => !!state.membership?.managedTeamIds.length);

  return useMemo(() => accessRoles(roles, companyRole, managesATeam), [roles, companyRole, managesATeam]);
}

const NO_ROLES: string[] = [];
